// An override is a stored row whose value diverges from the global. The
// endpoint applies that rule and reports the result in `overrides`; this
// filter trusts the field and never re-derives it by comparing values.
//
// Both the override lists and the page that owns their write paths need this
// set, and the page needs it in the SAME order the lists render: focus after a
// delete moves to the neighbouring row. Two copies of the sort would drift
// silently, landing focus on the wrong row with no test failing.
export default function overridingOrganizations(organizations, flagName) {
    return organizations
        .filter((organization) => organization.overrides.includes(flagName))
        .sort((a, b) => a.name.localeCompare(b.name))
}
